/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Info_Lock_ConfirmInputs */



/**
* | output |
* | --- |
* | "Yes, lock it" |
*
* @param {Explorer_Info_Lock_ConfirmInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_info_lock_confirm = /** @type {((inputs?: Explorer_Info_Lock_ConfirmInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Info_Lock_ConfirmInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Oui, verrouiller")
	if (locale === "de") return /** @type {LocalizedString} */ ("Ja, schließ es ab.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Sì, bloccalo")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Да, заблокируйте его.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Sí, ciérralo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("对，锁上。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("はい、ロックしてください")
	if (locale === "hi") return /** @type {LocalizedString} */ ("हां, इसे लॉक कर दो।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Sim, tranque-o.")
	return /** @type {LocalizedString} */ ("Yes, lock it")
});